<template>
  <div class="privacy-container">
    <div class="language-switch">
      <button @click="setLocale('en')">English</button>
      <button @click="setLocale('zh')">简体中文</button>
    </div>
    <h1 class="privacy-title">{{ $t('privacy.title') }}</h1>
    <p>{{ $t('privacy.updated') }}</p>
    <p>{{ $t('privacy.intro') }}</p>
    <h2 class="privacy-information">{{ $t('privacy.data.title') }}</h2>
    <ul>
      <li>{{ $t('privacy.data.info1') }}</li>
      <li>{{ $t('privacy.data.info2') }}</li>
      <li>{{ $t('privacy.data.info3') }}</li>
    </ul>
    <h2>{{ $t('privacy.storage.title') }}</h2>
    <ul>
      <li>{{ $t('privacy.storage.info1') }}</li>
      <li>{{ $t('privacy.storage.info2') }}</li>
    </ul>
    <h2>{{ $t('privacy.permissions.title') }}</h2>
    <p>{{ $t('privacy.permissions.info1') }}</p>
    <h2>{{ $t('privacy.purchase.title') }}</h2>
    <p>{{ $t('privacy.purchase.info1') }}</p>
    <h2>{{ $t('privacy.changes.title') }}</h2>
    <p>{{ $t('privacy.changes.info1') }}</p>
    <h2>{{ $t('privacy.contact.title') }}</h2>
    <p>{{ $t('privacy.contact.info1') }} <a href="mailto:nookapp.info@gmail.com">nookapp.info@gmail.com</a></p>
  </div>
</template>

<script>
export default {
  name: 'Privacy',
  methods: {
    setLocale (locale) {
      this.$i18n.locale = locale
    }
  }
}
</script>

<style lang="less" scoped>
  .privacy-container{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 3rem;
    max-width: 900px;
    margin: 0 auto;
    line-height: 1.6;
    .language-switch {
      align-self: flex-end;
      button {
        margin-left: 0.5rem;
        padding: 0.5rem 0.8rem;
        border: 1px solid #d8dce3;
        border-radius: 0.5rem;
        background: #fff;
        cursor: pointer;
      }
    }
    .privacy-title{
      font-weight: 600;
      font-size: 2rem;
    }
    .privacy-information{
      margin-top: 1rem;
      font-weight: 500;
      font-size: 1.8rem;
    }
    ul{
      padding: 1rem;
      li{
        padding-top: 0.5rem;
        padding-left: 0px;
        font-weight: 500;
        font-size: 1rem;
        color: gray;
        text-align: left;
      }
    }
    p {
      margin-top: 0.75rem;
      color: #667085;
      text-align: left;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Other/Privacy.vue